import { Component, OnDestroy, OnInit, forwardRef, Inject, Input } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { ICardComponentInjectionToken } from '@infrastructure/ValidationMessages/ExternalValidationDirective';
import { ModalService } from '@infrastructure/Modal/ModalService';
import { BeneficiaryListTableEditComponent } from '../../beneficiary-list-table-edit.component';
import { TableEditBase } from '@infrastructure/TableEdit/TableEditBase';
//import { DomainCodes } from '../../../../../../models/const.DomainCodes';
import { DropdownsValues } from '@infrastructure/Dropdowns/const.dropdowns';

import * as _ from 'lodash';
//import { BenefitChoosen } from '@infrastructure/Documents/benefit-choosen.enum';
import { LegalRepresentationStateService } from '@infrastructure/Beneficiaries/legal-representation-state.service';

@Component({
  selector: 'tax-information',
  templateUrl: './tax-information.component.html',
  providers: [
    {
      provide: ICardComponentInjectionToken,
      useExisting: forwardRef(() => BeneficiaryListTableEditComponent)
    }],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  standalone: false
})

export class TaxInformationComponent extends TableEditBase<models.BeneficiaryVM> implements OnInit, OnDestroy {

  @Input("cardData")
  public cardData: models.TaxInformationVM = {} as models.TaxInformationVM;

  @Input("personTypologyCode")
  public personTypologyCode: string;

  @Input("benefitType")
  public benefitType: models.BenefitTypeVM;

  @Input("hasLegalRepresentation")
  public hasLegalRepresentation: boolean;

  @Input("stateRL")
  public stateRL: number;

  @Input()  public fiscalCategories: models.DimensionVM[];
  @Input()  public incomeHoldings: models.DimensionVM[];

  //@Input() benefitChoosen: BenefitChoosen;
  //public BenefitChoosen = BenefitChoosen;

  public personTypeValues = DropdownsValues.dropDownPersonType;
  constructor(@Inject(BeneficiaryListTableEditComponent) public parent: Component, private modalService: ModalService,
    private beneficiariesStateService: LegalRepresentationStateService) {
    super(parent, modalService);

  }

  ngOnInit(): void {
  }

  ngOnDestroy(): void {
  }

  getOrderedIncomeHoldings() {
    return _.sortBy(this.incomeHoldings, x => x.value);
  }

  public onChangeIrsTable(newValue) {
    const description = this.fiscalCategories.find(el => el.code == newValue).description;
    this.cardData.irsTable = description;
  }

  public isNotStateRLDiferido(): boolean {
    const result = this.beneficiariesStateService
      .getStateDeferido(this.hasLegalRepresentation, this.stateRL?.toString());
    return !result;
  }

  public isNotSurvivalPensionOrSM(): boolean {
    const result = this.benefitType.funeralAllowanceBenefit?.toString() == 'true' ||
      this.benefitType.survivalPensionBenefit?.toString() == 'true';
    return !result;
  }
}
